// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__31L-X","notes":"Notes_notes__LwjBc","note":"Notes_note__2GI1A","markdown":"Notes_markdown__29hWM"};